
const initialState = {
  pawGroupMetrics: null,
  workflowErrorMetrics: null,
  pawGroupMetricsStatus: 'idle',
  workflowErrorMetricsStatus: 'idle',
  metricsFetcherStatus: 'idle'
};

export function Reducer (previousState = initialState, action) {
  let newState = Object.assign({}, previousState);
  switch (action.type) {
    case 'FETCH_PAW_GROUP_METRICS_REQUEST':
      newState = Object.assign({}, previousState, {
        pawGroupMetricsStatus: 'requested',
        metricsFetcherStatus: 'requested'
      });
      break;
    case 'FETCH_PAW_GROUP_METRICS_SUCCESS':
      newState = Object.assign({}, previousState, {
        pawGroupMetrics: {...action.payload, requestDateTime: new Date()},
        pawGroupMetricsStatus: 'success',
        metricsFetcherStatus: newState.workflowErrorMetricsStatus === 'requested' ? 'requested' : 'success'
      });
      break;
    case 'FETCH_PAW_GROUP_METRICS_FAILURE':
      newState = Object.assign({}, previousState, {
        pawGroupMetricsStatus: 'failure',
        metricsFetcherStatus: newState.workflowErrorMetricsStatus === 'requested' ? 'requested' : 
                              newState.workflowErrorMetricsStatus === 'success' ? 'success' : 'failure'
      });
      break;
    case 'FETCH_WORKFLOW_ERROR_METRICS_REQUEST':
      newState = Object.assign({}, previousState, {
        workflowErrorMetricsStatus: 'requested',
        metricsFetcherStatus: 'requested'
      });
      break;
    case 'FETCH_WORKFLOW_ERROR_METRICS_SUCCESS':
      newState = Object.assign({}, previousState, {
        workflowErrorMetrics: {...action.payload, requestDateTime: new Date()},
        workflowErrorMetricsStatus: 'success',
        metricsFetcherStatus: newState.pawGroupMetricsStatus === 'requested' ? 'requested' : 'success'
      });
      break;
    case 'FETCH_WORKFLOW_ERROR_METRICS_FAILURE':
      newState = Object.assign({}, previousState, {
        workflowErrorMetricsStatus: 'failure',
        metricsFetcherStatus: newState.pawGroupMetricsStatus === 'requested' ? 'requested' : 
                              newState.pawGroupMetricsStatus === 'success' ? 'success' : 'failure'
      });
      break;
    case 'METRICS_FETCHER_STATUS_RESET':
      newState = Object.assign({}, previousState, {metricsFetcherStatus: 'idle'}); 
      break;
    default:
      break;
  }

  return newState;
}